import type { FunctionComponent } from 'react';

import { useAssetPath } from '../../utils/asset-path';

export interface IImageLogoProps {
    className?: string;
    srcPath: string;
}

export const ImageLogo: FunctionComponent<IImageLogoProps> = ({ className, srcPath }) => {
    const path = useAssetPath(srcPath);

    return <img className={className} src={path} />;
};
